/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect } from 'react';

// local imports
import { OrderService } from 'app/services';
import useDataApi from '../../use-data-api';
import { FormatUtils, TableUtils } from 'app/utils';
import { mapDeliveryTypes, mapOrderStatuses } from 'app/utils/mapper';
import { CustomBadge } from 'app/components/atoms';

const useOrdersListService = (queries, isFilteringRef) => {
  const [service, setService] = useDataApi();

  const fetchData = useCallback(async () => {
    const orderList = await OrderService.getOrdersList(queries);
    const orders = orderList.data.data;

    const out = orders?.map(item => {
      const { id, name, surname, telephone, delivery_type, status, created_at, ...rest } = item;

      const deliveryType = mapDeliveryTypes(delivery_type.id);
      const orderStatuses = mapOrderStatuses(status.id);

      return {
        ...rest,
        id,
        name: name + ' ' + surname,
        delivery_type: deliveryType,
        status: (
          <CustomBadge
            content={orderStatuses.text}
            status={orderStatuses.color}
            customClassName="min-w-128"
          />
        ),
        telephone: FormatUtils.formatPhoneNumber(telephone),
        created_at: FormatUtils.convertDateString(created_at)
      };
    });

    isFilteringRef.current = false;

    return {
      table: {
        columns: TableUtils.orderList,
        rows: out
      },
      totalCount: orderList?.data?.total_count,
      total: Math.round(orderList?.data?.total_count / parseInt(queries.limit))
    };
  }, [queries]);

  useEffect(() => setService(() => fetchData()), [setService, fetchData]);

  const handleRefresh = async () => {
    setService(() => fetchData());
  };

  return {
    service,
    handleRefresh
  };
};

export default useOrdersListService;
